import { MatchCellLayout } from './MatchCellLayout';
import { ChipTime } from '../../../ChipTime';
import { MatchCompetitorHighlightable } from '../MatchCompetitorHighlightable';
import { useTheme } from '@mui/material/styles';
import { useMatchCompetitors } from '../../../../hooks/useMatchCompetitors';
import { MatchLiveBadge } from '../MatchLiveBadge';
import { ReactNode } from 'react';
import { useMatch } from '../MatchProvider';

export type MatchCellProps = {
  isLarge?: boolean;
  Button?: ReactNode;
};

export const MatchCell: React.FC<MatchCellProps> = ({
  isLarge = false,
  Button,
}) => {
  const theme = useTheme();
  const { startTime, status } = useMatch();

  const { MatchCompetitors } = useMatchCompetitors({
    CompetitorComponent: MatchCompetitorHighlightable,
  });

  // TODO: Show startTime to user once design has been finalized
  // and we are confident in our match scheduling
  return (
    <MatchLiveBadge>
      <MatchCellLayout
        sx={{
          ...(status === 'delayed' || status === 'active'
            ? theme.glow.panel
            : {}),
          width: isLarge ? 228 : 180,
          background:
            status === 'disabled'
              ? theme.palette.action.disabledOpaque
              : `linear-gradient(${theme.palette.background.elevationSolid[10]}, 
              ${theme.palette.background.elevationSolid[10]}), ${theme.palette.primary.vertical}`,
        }}
        Overlay={startTime && <ChipTime time={startTime} />}
        Competitors={MatchCompetitors}
        Interaction={Button}
      />
    </MatchLiveBadge>
  );
};
